import { render } from "./SectorForm.vue?vue&type=template&id=49e0f12e&scoped=true"
import script from "./SectorForm.vue?vue&type=script&lang=js"
export * from "./SectorForm.vue?vue&type=script&lang=js"

import "./SectorForm.vue?vue&type=style&index=0&id=49e0f12e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e0f12e"]])

export default __exports__